const API_URL = process.env.VUE_APP_API_URL+'/office'

//import { router } from '../main.js'
import { userService } from './userServices.js';

export const rilieviApi = {
 getRilievi,getRilieviCollegati,
 getAcList,
 getDc,
lookupVr,
lookupVrWithDetails,
confermaRilievo,
};

function getAcList(comune) {
    const sid = userService.getSessionId()
    
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune })
    };

    const url=API_URL + '/rilievi/getAcList';
    
    return fetch(url, requestOptions).then(userService.handleResponse)
        .then(ret => {
          
          
            if (ret) {

                return ret;
            }

            return 'errore';
        });
}
function getDc(comune,uniqueId) {
    const sid = userService.getSessionId()
    
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune,uniqueId })
    };

    const url=API_URL + '/rilievi/getDc';
    
    return fetch(url, requestOptions).then(userService.handleResponse)
        .then(ret => {
          
          
            if (ret) {

                return ret;
            }

            return 'errore';
        });
}



function getRilieviCollegati(uniqueId) {
    const sid = userService.getSessionId()
    var comune=userService.getStoreCurrentComune();
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune, uniqueId})
    };

    const url=API_URL + '/rilievi/getRilieviCollegati';
    
    return fetch(url, requestOptions).then(userService.handleResponse)
        .then(ret => {
          
          
            if (ret) {

                return ret;
            }

            return 'errore';
        });
}

function getRilievi(comune,acUid,fromRow,pageSize) {
    const sid = userService.getSessionId()
    
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune, acUid,fromRow,pageSize })
    };

    const url=API_URL + '/rilievi/getRilieviAc';
    
    return fetch(url, requestOptions).then(userService.handleResponse)
        .then(ret => {
          
          
            if (ret) {

                return ret;
            }

            return 'errore';
        });
}

function lookupVr(comune,prgAc,filter,fromRow,pageSize) {
    const sid = userService.getSessionId()
    
    
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune, prgAc,filter,fromRow,pageSize })
    };
    
    const url=API_URL + '/ana/lookupVr';
    //alert(JSON.stringify(url))
    return fetch(url, requestOptions).then(userService.handleResponse)
        .then(ret => {
          
          
            if (ret) {

                return ret;
            }

            return 'errore';
        });
}
function lookupVrWithDetails(comune,prgAc) {
    const sid = userService.getSessionId()
    
    
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune, prgAc })
    };
    
    const url=API_URL + '/lookup/lookupVrWithDetails';
    //alert(JSON.stringify(url))
    return fetch(url, requestOptions).then(userService.handleResponse)
        .then(ret => {
          
          
            if (ret) {

                return ret;
            }

            return 'errore';
        });
}
function confermaRilievo(comune,rilievo,prgFrazione) {
    const sid = userService.getSessionId()
    
    
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune,rilievo,prgFrazione})
    };
    
    const url=API_URL + '/rilievi/confermaRilievo';
    //alert(JSON.stringify(url))
    return fetch(url, requestOptions).then(userService.handleResponse)
        .then(ret => {
          
          
            if (ret) {

                return ret;
            }

            return 'errore';
        });
}




